import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "../../components/DialogTitle/DialogTitle";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { API_POST } from "../../services/api.service";
import { getToken } from "../../services/Common.js";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";

function GoogleFormIntegration(props) {
  const { user, open, handleClose } = props;
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [formId, setFormId] = useState("");
  const [generatedCode, setGeneratedCode] = useState("");
  const [notify, setNotify] = useState({
    open: false,
    message: "",
    color: "success",
  });

  useEffect(() => {
    if (user) {
      loadCampaigns();
    }
  }, [user]);

  const loadCampaigns = async () => {
    try {
      const response = await API_POST("action/getdata", {
        root: "campaigns",
        con: { admin: user && user.admin, IsActive: true },
      });
      if (response && response.status === 200) {
        setCampaigns(response.data);
      }
    } catch (error) {
      console.error("Error loading campaigns:", error);
    }
  };

  useEffect(() => {
    if (selectedCampaign && formId) {
      generateCode();
    } else {
      setGeneratedCode("");
    }
  }, [selectedCampaign, formId]);

  const generateCode = () => {
    const token = getToken();
    const admin = user && user.username;
    const cid = selectedCampaign ? selectedCampaign._id : "";
    
    const code = `
// ===== FORM CONFIGURATION ===== 
const FORM_CONFIG = { 
   
  // form id is the key dynamic  
  "${formId}": { 
    apiUrl: "https://web.betyphon.in/api/action/addProspects", 
    admin: "${admin}", 
    cid: "${cid}", 
    headers: { 
      "Authorization": "Bearer ${token}" 
    } 
  }, 
 
}; 
 
 
// ===== FORM SUBMIT HANDLER ===== 
function onFormSubmit(e) { 
 
  if (!e || !e.response) { 
    Logger.log("Invalid event object"); 
    return; 
  } 
 
  // detect which form triggered 
  const formId = e.source.getId(); 
  const config = FORM_CONFIG[formId]; 
 
  if (!config) { 
    Logger.log("No configuration found for form: " + formId); 
    return; 
  } 
 
  const payload = {}; 
  const responses = e.response.getItemResponses(); 
 
  responses.forEach((item) => { 
 
    const question = item.getItem().getTitle(); 
    const answer = item.getResponse(); 
 
    const key = question 
      .toLowerCase() 
      .replace(/[^a-z0-9]/g, "_"); 
 
    payload[key] = answer; 
 
  }); 
 
  // add config params 
  payload.admin = config.admin; 
  payload.cid = config.cid; 
 
  // metadata 
  //payload.form_id = formId; 
  //payload.submitted_at = e.response.getTimestamp(); 
 
  Logger.log(payload); 
 
  const options = { 
    method: "post", 
    headers: config.headers, 
    contentType: "application/json", 
    payload: JSON.stringify(payload), 
    muteHttpExceptions: true 
  }; 
 
  const res = UrlFetchApp.fetch(config.apiUrl, options); 
 
  Logger.log(res.getContentText()); 
}
`;
    setGeneratedCode(code.trim());
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle id="google-form-dialog-title" onClose={handleClose}>
        Google Form App Script Integration
      </DialogTitle>
      <DialogContent dividers>
        <GridContainer>
          <GridItem xs={12} sm={6}>
            <Autocomplete
              options={campaigns}
              getOptionLabel={(option) => option.name || ""}
              value={selectedCampaign}
              onChange={(event, newValue) => setSelectedCampaign(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Select Campaign" variant="outlined" margin="normal" fullWidth />
              )}
            />
          </GridItem>
          <GridItem xs={12} sm={6}>
            <TextField
              label="Google Form ID"
              variant="outlined"
              margin="normal"
              fullWidth
              value={formId}
              onChange={(e) => setFormId(e.target.value)}
              placeholder="Enter your Google Form ID"
            />
          </GridItem>
          {generatedCode && (
            <GridItem xs={12}>
              <div style={{ marginTop: "20px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                  <h4 style={{ margin: 0 }}>Generated App Script Code</h4>
                  <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => {
                      navigator.clipboard.writeText(generatedCode);
                      setNotify({ open: true, message: "Code copied to clipboard!", color: "success" });
                    }}
                  >
                    Copy Code
                  </Button>
                </div>
                <pre style={{ 
                  backgroundColor: "#f4f4f4", 
                  padding: "15px", 
                  borderRadius: "4px", 
                  overflowX: "auto",
                  fontSize: "12px",
                  maxHeight: "400px",
                  border: "1px solid #ddd"
                }}>
                  {generatedCode}
                </pre>
                <p style={{ fontSize: "13px", color: "#666", marginTop: "10px" }}>
                  <b>Instructions:</b> Open your Google Form, go to Extensions -{">"} App Script, paste this code and save it. Then set up a trigger for "On form submit".
                </p>
              </div>
            </GridItem>
          )}
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Close
        </Button>
      </DialogActions>
      <Snackbar
        place="tr"
        color={notify.color}
        icon="check"
        message={notify.message}
        open={notify.open}
        closeNotification={() => setNotify({ ...notify, open: false })}
        close
      />
    </Dialog>
  );
}

export default GoogleFormIntegration;
